import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=27de7866&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27de7866"]])

export default __exports__